module.exports = __webpack_public_path__ + "img/xt6@2x.9a757209.png";